import { render, staticRenderFns } from "./AlreadyOwnedENSContainer.vue?vue&type=template&id=e67d327e&scoped=true&lang=html&"
import script from "./AlreadyOwnedENSContainer.vue?vue&type=script&lang=js&"
export * from "./AlreadyOwnedENSContainer.vue?vue&type=script&lang=js&"
import style0 from "./AlreadyOwnedENSContainer.vue?vue&type=style&index=0&id=e67d327e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67d327e",
  null
  
)

export default component.exports